import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";

const videos = [
  {
    url: "https://youtu.be/7pbRPepVy6k?si=4Bo53cKOvwkAJayu",
    poster: "https://img.youtube.com/vi/7pbRPepVy6k/maxresdefault.jpg",
    title: "Olivia C. Dacal - My Tragic Love Story",
    type: "youtube",
  },
  {
    url: "https://youtu.be/2Gk_GHdQKgk?si=slla7HZoBrfr2ucQ",
    poster: "https://img.youtube.com/vi/2Gk_GHdQKgk/maxresdefault.jpg",
    title: "Para, Siempre",
    type: "youtube",
  },
  {
    url: "https://youtu.be/3maG2eBL-0A?si=xqDul2mw5ds6TNHm",
    poster: "https://img.youtube.com/vi/3maG2eBL-0A/maxresdefault.jpg",
    title: "Storm Reed - CLEAN SWEEP",
    type: "youtube",
  },
];

const getYouTubeEmbedUrl = (url) => {
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^?&]+)/);
  return match ? `https://www.youtube.com/embed/${match[1]}` : url;
};

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const Production = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (selectedVideo && !e.target.closest(".video-modal")) {
        setSelectedVideo(null);
      }
    };

    const handleEscape = (e) => {
      if (e.key === "Escape") {
        setSelectedVideo(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("keydown", handleEscape);
    };
  }, [selectedVideo]);

  return (
    <div className="gallery-container m-10 mt-10">
      <div className="grid md:grid-cols-3 gap-10 mt-10">
        {videos.map((video, index) => (
          <motion.div
            key={index}
            custom={index}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="relative group cursor-pointer overflow-hidden"
            onClick={() => setSelectedVideo(video)}
          >
            <div className="aspect-w-16 aspect-h-9">
              <img
                src={video.poster}
                alt={video.title || `Production ${index + 1}`}
                className="object-cover object-center w-full h-full transform transition-transform duration-300 group-hover:scale-105"
                onError={(e) => {
                  if (e.target.src.includes('maxresdefault.jpg')) {
                    e.target.src = e.target.src.replace('maxresdefault.jpg', 'hqdefault.jpg');
                  }
                }}
              />
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <FontAwesomeIcon icon={faPlay} className="w-8 h-8 text-white opacity-90 drop-shadow-md" />
              </div>
            </div>
            {video.title && (
              <p className="absolute bottom-3 left-3 text-white text-sm font-medium tracking-wide drop-shadow-md">
                {video.title}
              </p>
            )}
          </motion.div>
        ))}
      </div>

      {selectedVideo && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-75 flex justify-center items-center video-modal">
          <div className="max-w-4xl w-full relative px-4">
            <button
              onClick={() => setSelectedVideo(null)}
              className="absolute -top-10 right-4 text-white text-3xl z-10 focus:outline-none"
            >
              &times;
            </button>
            {selectedVideo.type === "youtube" ? (
              <div className="aspect-w-16 aspect-h-9">
                <iframe
                  src={getYouTubeEmbedUrl(selectedVideo.url)}
                  title={selectedVideo.title || "Production video"}
                  className="w-full h-[60vh]"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            ) : (
              <video
                src={selectedVideo.url}
                controls
                autoPlay
                className="w-full h-[60vh] object-contain"
                poster={selectedVideo.poster}
              >
                Your browser does not support the video tag.
              </video>
            )}
            {selectedVideo.title && (
              <p className="text-center text-white text-lg mt-4">
                {selectedVideo.title}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Production;
